import store from '@/store'
import validateSpanishID from '@/helpers/validateSpanishID'

export default {
  getMessage(field, args) {
    return field
  },
  validate(value, args) {
    const country = value.substring(0, 2)
    const ID = value.substring(2, value.length - 4)
    const validCountry = country === 'ES'
    const validCIF = store.state.invoice.provider.document !== ID && validateSpanishID(ID, 'LP')
    const validID = validateSpanishID(ID, 'NP')
    return validCountry && (validCIF || validID)
  }
}
